export class IdentityDocumentTypeDto {
    id!: number;
    name!: string;
    description!: string;
}
